
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2" viewBox="0 0 512 512"><path d="m32 0 40.8 460.8L256 512l183.136-51.168L480 0H32Zm360.768 150.688-5.152 57.888-15.52 173.568L256 414.208l-.064.032-116-32.128-8.128-90.752h56.832l4.224 47.104 63.072 17.024.064-.064 63.136-17.024 8.608-78.432-198.656.544-5.632-53.664 209.056-2.432 4.224-57.44-218.88.608-3.68-53.376h283.648l-5.056 56.48Z" style="fill-rule:nonzero"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    